export class OrganizerTimeModel {
  // Epoch time milliseconds
  start: number;
  end: number;
  quarter: number;
  year: number;

  constructor(start: number, end: number) {
    this.start = start;
    this.end = end;
  }
}
